// src/App.js
import React from 'react';
import AppRouter from './router/index';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

// Each site's own stylesheet is loaded by its layout (router/Layout.js, router/WebsiteLayout.js),
// so the website and admin themes never end up on the same page.
function App() {
  return (
    <div>
      <AppRouter />
      <ToastContainer />
    </div>
  );
}

export default App;
